export const getClassName = (className: string, customClassName: string): string => {
  let classNameValue = className;
  if (customClassName) {
    classNameValue = `${classNameValue} ${customClassName}`
  }
  return classNameValue;
}